import { BasePluginService } from "../base/base-plugin-service";

export class VChartPluginService extends BasePluginService {
    constructor(globalInstance) {
        super(), this.globalInstance = globalInstance;
    }
    onInit() {
        this._plugins.forEach((plugin => {
            plugin.onInit && plugin.onInit(this);
        }));
    }
    releaseAll() {
        super.releaseAll(), this.globalInstance = null;
    }
}
//# sourceMappingURL=plugin-service.js.map
